module.exports = __webpack_public_path__ + "img/yl3065.8cf0fe09.png";